module.exports = __webpack_public_path__ + "static/media/03A.3ab75d95.png";